import { render, staticRenderFns } from "./dyDetails.vue?vue&type=template&id=1ed35019&scoped=true"
import script from "./dyDetails.vue?vue&type=script&lang=js"
export * from "./dyDetails.vue?vue&type=script&lang=js"
import style0 from "./dyDetails.vue?vue&type=style&index=0&id=1ed35019&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed35019",
  null
  
)

export default component.exports